/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    Auth: {
        Cognito: {
            userPoolId: "us-east-2_C7Zl7OTI1",
            userPoolClientId: "61junkfaas0egho45e9q71uljj",
            identityPoolId: "us-east-2:4f8d7c88-8890-4de1-9c00-d9b635199ee8",
            signUpVerificationMethod: "code",
            loginWith: {
                oauth: {
                    scopes: [
                        "aws.cognito.signin.user.admin",
                        "email",
                        "openid",
                        "phone",
                        "profile"
                    ],
                    redirectSignIn: ["http://localhost:3000/", "https://www.pretectum.com/"],
                    redirectSignOut: ["http://localhost:3000/", "https://www.pretectum.com/"],
                    responseType: "code"
                }
            }
        }
    },
    Storage: {
        S3: {
            bucket: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_BUCKET_REGION
        }
    }
};


export default awsmobile;
